import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useTourCompletions() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: completedTourIds = [], isLoading } = useQuery({
    queryKey: ['tour-completions', user?.id],
    queryFn: async () => {
      if (!user?.id) return [];
      const { data, error } = await supabase
        .from('tour_completions' as any)
        .select('tour_id')
        .eq('user_id', user.id);
      if (error) throw error;
      return (data as any[]).map((r) => r.tour_id as string);
    },
    enabled: !!user?.id,
  });

  const { mutate: markComplete } = useMutation({
    mutationFn: async (tourId: string) => {
      if (!user?.id) return;
      const { error } = await supabase
        .from('tour_completions' as any)
        .upsert(
          { user_id: user.id, tour_id: tourId },
          { onConflict: 'user_id,tour_id' }
        );
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tour-completions'] });
    },
  });

  return {
    completedTourIds,
    isLoading,
    markComplete,
    isCompleted: (tourId: string) => completedTourIds.includes(tourId),
  };
}
